import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class RetiredMilitary extends Component {
  onChange(item) {
    var retiredMilitaryIndex = _.findIndex(
      this.props.filterState.filterData.retiredMilitary,
      (o) => {
        return o.retiredMilitary === item.retiredMilitary;
      }
    );
    item.checked = !this.props.filterState.filterData.retiredMilitary[
      retiredMilitaryIndex
    ].checked;
    this.props.filterState.filterData.retiredMilitary[
      retiredMilitaryIndex
    ] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item, index) {
    return (
      <li class="chechbox-list_item" key={"rmliitem-" + index}>
        <span
          className="card-text custom-checkbox ml-3 mr-4"
          key={"rmitem-" + index}
        >
          <input
            type="checkbox"
            htmlFor={"rmitem-" + index}
            value={index}
            checked={item.checked}
            className="custom-control-input"
            id={"rmitem-" + index}
            name={"rmitem-" + index}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            style={{ color: this.props.isMobile ? "white" : null }}
            htmlFor={"rmitem-" + index}
          >
            {item.retiredMilitary}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Retired Military</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div class="filter-fields-scroll">
          <ul class="chechbox-list">
            {this.props.filterState.filterData.retiredMilitary &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.retiredMilitary.map(
                (item, index) => this.chechboxes(item, index)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(RetiredMilitary);
